import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { CatalogBody, CatalogDetails, CatalogListItem } from "types/api/catalog";

import { AdvancedListRequest } from "types/api/commons";

function useCatalogApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllCatalog = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<CatalogListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<CatalogListItem>>({
            url: "/catalog",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneCatalog = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<CatalogDetails> => {
        return get<PathParamsWithId, undefined, CatalogDetails>({
            url: "/catalog/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createCatalog = React.useCallback((body: CatalogBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, CatalogBody, ResponseWithId>({
            url: "/catalog",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateCatalog = React.useCallback((pathParams: PathParamsWithId, body: CatalogBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, CatalogBody, null>({
            url: "/catalog/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteCatalog = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/catalog/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllCatalog,
        getOneCatalog,
        createCatalog,
        updateCatalog,
        deleteCatalog
    };
}

export default useCatalogApi;